import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//Dashboard
import Dashboard from "./dashboard/reducer"
import MessageDashBoard from "./dashboard/message/reducer"
import Type from "./config/type/reducer"
import AreaUser from "./areas/areaUser/reducer"
import Users from "./users/homeUsers/reducer"

//Concept
import Concept from "./config/concept/reducer"
//monitor
import Monitor from "./monitor/order/reducer"
import SupplierMonitor from "./monitor/supplier/reducer"
import TypeMonitor from "./monitor/type/reducer"
import OrdersCount from "./monitor/orderCount/reducer"
//Supplier
import Suppliers from "./supplier/reducer"
//cosiety
import Society from "./society/reducer"
import PaymentDetail from "./paymentDetail/reducer"
import Banks from "./banks/reducer"
import fileRequirement from "./filesrequirement/reducer"
import fileUpload from "./fileUpload/reducer"
// Notification email
import NotificationsEmail from "./notificationsEmail/reducer"
import materialSupplier from "./materialSupplier/reducer"
const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Dashboard,
  Concept,
  Type,
  AreaUser,
  Monitor,
  SupplierMonitor,
  TypeMonitor,
  Users,
  Suppliers,
  Society,
  OrdersCount,
  MessageDashBoard,
  Banks,
  PaymentDetail,
  fileRequirement,
  fileUpload,
  NotificationsEmail,
  materialSupplier,
})

export default rootReducer
